import { render, staticRenderFns } from "./MailSendDialog.vue?vue&type=template&id=d09635a4&scoped=true&lang=pug"
import script from "./MailSendDialog.vue?vue&type=script&lang=js"
export * from "./MailSendDialog.vue?vue&type=script&lang=js"
import style0 from "./MailSendDialog.vue?vue&type=style&index=0&id=d09635a4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d09635a4",
  null
  
)

export default component.exports